export function os() {
	if (navigator.userAgent.includes("Win")) return "Windows OS"
	if (navigator.userAgent.includes("Mac")) return "MacOS"
	if (navigator.userAgent.includes("X11")) return "UNIX OS"
	if (navigator.userAgent.includes("Linux")) return "Linux OS"
	return "Unknown"
}
